import { ASSET_PREFIX, colors } from 'utils/constants';

/** Autogenerated JSDoc comment, so that the build passes
 * @param {Object} props
 * @param {React.ReactNode} props.children
 * @param {function} [props.onClose]
 * @param {boolean} [props.withCloseButton=true]
 * @param {Object} [props.style]
 * @param {'left'} [props.align]
 * @param {string|undefined} [props.ariaLabelledByElementId]
 * @param {boolean|undefined} [props.noParagraphStyleOverrides]
 */
const GenericModal = ({
  children,
  onClose,
  withCloseButton = true,
  style = undefined,
  /** Text and content alignment - 'left', or defaults to center if unspecified */
  align = undefined,
  ariaLabelledByElementId = undefined,
  noParagraphStyleOverrides = false,
}) => (
  <div
    className={`container ${align === 'left' ? 'left' : ''}`}
    id="dimmedBackground"
    onClick={(e) => e.target.id === 'dimmedBackground' && onClose && onClose()}
  >
    <div
      id="message"
      style={{ ...style }}
      role="dialog"
      aria-labelledby={ariaLabelledByElementId}
    >
      {onClose && withCloseButton && (
        <img
          id="closeButton"
          src={`${ASSET_PREFIX}/images/close_button.svg`}
          style={{ cursor: 'pointer', width: '20px' }}
          onClick={onClose}
          alt="close button - cross"
        />
      )}
      {children}
    </div>

    <style jsx>{`
      .container {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        max-width: 100%;
        height: 100%;
        background-color: rgba(55, 55, 55, 0.8);
        z-index: 999;
      }

      #message {
        position: relative;
        background-color: white;
        color: ${colors.primaryBrandGray};
        top: 50%;
        left: 50%;
        width: 94%;
        max-width: 500px;
        max-height: 95%;
        overflow-y: auto;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);

        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 5em 2em 4em;
        border-radius: 18px;
        box-shadow: 0 0 15px #333;
        z-index: 1000;
        text-align: center;
      }

      @media (min-width: 768px) {
        #message {
          border-radius: 24px;
        }
      }

      .container.left #message {
        text-align: left;
        align-items: start;
      }

      .container :global(ul) {
        margin-top: 0;
      }

      #message * {
        flex-shrink: 0;
      }

      @media (max-width: 350px) {
        #message {
          width: 98%;
        }
      }

      #closeButton {
        position: fixed;
        width: 20px;
        height: 20px;
        right: 16px;
        top: 16px;
      }

      h2 {
        margin-top: 5px;
      }

      h4,
      h2 {
        text-shadow: 2px 2px ${colors.brand.pastel};
      }

      @media (min-width: 400px) {
        #message {
          padding: 4em 2.5em;
        }
      }

      :global(#message p) {
        ${noParagraphStyleOverrides ? '' : 'font-size: 1rem;'}
      }
      @media (min-width: 1000px) {
        :global(#message p) {
          ${noParagraphStyleOverrides ? '' : 'font-size: 1.1rem;'}
        }
      }
    `}</style>
  </div>
);

export default GenericModal;
